import React from 'react';
import InputsTamplate from '../template/InputsTamplate';
import { useTranslation } from "react-i18next";
const SortStaticValueToInputs = ({currentItem, setWitdh, height, setHeight, validationHeight, width, isPosterDisabled, validationWidth, count, setCount, validationCount}) => {
    const { t } = useTranslation();
    return (
        <div className="wrap_row">
        {currentItem &&
        currentItem?.nameUa == "Кольорова плівка серії Oracal 641" || currentItem?.nameUa == "Самоклеючий папір" || currentItem?.nameUa == "Самоклеюча плівка" ? (
          <>
          {currentItem?.nameUa == "Кольорова плівка серії Oracal 641" &&
          <>
                      <div className="calc-item input_size">
              <InputsTamplate
                title={"Width"}
                type={"number"}
                placeholder={"Enter the width in mm"}
                value={1000}
                handleCangeInput={setWitdh}
                disabled={true}
              />
            </div>
            <div className="calc-item input_size">
              <InputsTamplate
                title={"Height"}
                type={"number"}
                placeholder={"Enter the height in mm"}
                value={height}
                handleCangeInput={setHeight}
              />
              {validationHeight && (
                <p style={{ color: "red" }}>{t(`Validation height`)}</p>
              )}
            </div>
          </>
          }
          {currentItem?.nameUa == "Самоклеючий папір" &&
                    <>
                    <div className="calc-item input_size">
                       <InputsTamplate
                        title={"Width"}
                        type={"number"}
                        placeholder={"Enter the width in mm"}
                        value={320}
                        handleCangeInput={setWitdh}
                        disabled={true}
                      />
                    </div>
                    <div className="calc-item input_size">
                        <InputsTamplate
                        title={"Height"}
                        type={"number"}
                        placeholder={"Enter the height in mm"}
                        value={450}
                        handleCangeInput={setHeight}
                        disabled={true}
                      />
                      {validationHeight && (
                        <p style={{ color: "red" }}>{t(`Validation height`)}</p>
                      )}
                    </div>
                  </>
          }
          {currentItem?.nameUa == "Самоклеюча плівка" &&
          <>
            <div className="calc-item input_size">
                <InputsTamplate
                title={"Width"}
                type={"number"}
                placeholder={"Enter the width in mm"}
                value={320}
                handleCangeInput={setWitdh}
                disabled={true}
              />
            </div>
            <div className="calc-item input_size">
                <InputsTamplate
                title={"Height"}
                type={"number"}
                placeholder={"Enter the height in mm"}
                value={450}
                handleCangeInput={setHeight}
                disabled={true}
              />
              {validationHeight && (
                <p style={{ color: "red" }}>{t(`Validation height`)}</p>
              )}
            </div>
          </>
          }
          </>
        ) : (
          <>
            <div className="calc-item input_size">
              <InputsTamplate
                title={"Width"}
                type={"number"}
                placeholder={"Enter the width in mm"}
                value={width}
                handleCangeInput={setWitdh}
                disabled={isPosterDisabled}
              />
              {validationWidth && (
                <p style={{ color: "red" }}>{t(`Validation width`)}</p>
              )}
            </div>
            <div className="calc-item input_size">
              <InputsTamplate
                title={"Height"}
                type={"number"}
                placeholder={"Enter the height in mm"}
                value={height}
                handleCangeInput={setHeight}
                disabled={isPosterDisabled}
              />
              {validationHeight && (
                <p style={{ color: "red" }}>{t(`Validation height`)}</p>
              )}
            </div>
          </>
        )}
        <div className="calc-item input_size">
          <InputsTamplate
            title={"Circulation"}
            type={"number"}
            placeholder={"Enter circulation"}
            value={count}
            handleCangeInput={setCount}
          />
          {validationCount && (
            <p style={{ color: "red" }}>{t(`Validation circulation`)}</p>
          )}
        </div>
      </div>
    );
};

export default SortStaticValueToInputs;